export default "__VITE_ASSET__e8ac4936__"